import React, { useState, useEffect, useCallback } from "react";
import { TreeList, orderBy, filterBy } from "@progress/kendo-react-treelist";
import { EditingAddDialog } from "../../../components/parsetEditor/EditingAddDialog";
import { getColumns } from "./treeListColumns";
import { removePropertyByPath } from "../../../utils/jsonUtils"

const subItemsField = "children";
const expandField = "expanded";

export const KendoTreeList = ({ data, typeComponent, setValue }) => {
    const [dto, setDto] = useState(data);
    const [open, setOpen] = useState(false);
    const [objectEdit, setObjectEdit] = useState({});
    const [action, setAction] = useState('ADDCHILDREN');
    const [path, setPath] = useState('');
    const [state, setState] = useState({
        data: [],
        dataState: {
            sort: [{ field: "field" }],
            filter: []
        }
    });

    const propertys = {
        prop1: {
            key: typeComponent === "parser" ? "field_value" : "operator",
            label: typeComponent === "parser" ? "Valor" : "Operador"
        },
        prop2: {
            key: typeComponent === "parser" ? "type" : "evaluation_result",
            label: typeComponent === "parser" ? "Tipo" : "Valor a comparar"
        }
    }

    const onExpandChange = (event) => {
        const updatedData = [...state.data];
        const toggleExpand = (items) => {
            return items.map(item => {
                if (item.id === event.dataItem.id) {
                    return { ...item, expanded: !event.value };
                } else if (item.children) {
                    return { ...item, children: toggleExpand(item.children) };
                }
                return item;
            });
        };

        setState({
            ...state,
            data: toggleExpand(updatedData)
        });
    };

    const Recurrent = useCallback((obj, pth = '', ids = null) => {
        const { prop1, prop2 } = propertys;
        const array = [];
        Object.keys(obj).forEach((item, idx) => {
            const pt = pth ? `${pth}/${item}` : item
            const id = ids ? `${ids}.${idx.toString()}` : idx.toString();
            if (typeof obj[item] === "object") {
                const jsn = obj[item];
                if (jsn.hasOwnProperty(prop1.key) && jsn.hasOwnProperty(prop2.key)) {
                    array.push({
                        id: id,
                        field: item,
                        [prop1.key]: jsn?.[prop1.key] || '',
                        [prop2.key]: jsn?.[prop2.key] || '',
                        functions: jsn?.functions || [],
                        path: pt
                    });
                }
                else {
                    array.push({
                        id: id,
                        field: item,
                        expanded: true,
                        path: pt,
                        children: Recurrent(jsn, pt, id)
                    });
                }
            }
            else {
                array.push({
                    id: id,
                    field: item,
                    [prop1.key]: obj[item],
                    typeOf: typeof obj[item],
                    path: pt
                });
            }
        })
        return array;
    }, []);

    useEffect(() => {
        const array = Recurrent(dto);
        setState({
            ...state,
            data: array
        });
    }, [dto]);

    const handleEdit = (obj, action) => {
        if (action === 'ADDNEWOBJECT') {
            setObjectEdit({});
            setPath('');
        }
        else {
            setPath(obj.path);
            if (action === 'EDIT')
                setObjectEdit(obj);
            else
                setObjectEdit({});
        }
        setAction(action);
        setOpen(true);
    }

    const handleDelete = (obj) => {
        const dtoSave = removePropertyByPath(dto, obj.path);
        setDto(dtoSave);
        setValue(dtoSave);
    }

    const handleSave = (obj, prop = '') => {
        let dtoSave = {};
        const { prop1, prop2 } = propertys;
        setDto(prevData => {
            try {
                const newData = { ...prevData };
                let current = newData;
                let keys = [];
                if (path.includes('/'))
                    keys = path.split('/');

                for (let i = 0; i < keys.length - 1; i++) {
                    const key = keys[i];
                    if (!current[key] || typeof current[key] !== "object") {
                        current[key] = {};
                    }
                    current = current[key];
                }

                const lastKey = keys[keys.length - 1] || prop;
                if (action === 'ADDNEWOBJECT') {
                    current[prop] = (obj[prop1.key] && obj[prop2.key]) ?
                        {
                            [prop1.key]: obj[prop1.key] || '',
                            [prop2.key]: obj[prop2.key] || '',
                            functions: obj?.functions || []
                        } : {};
                }
                else {
                    if (action === 'EDIT') {
                        current[lastKey] = {
                            [prop1.key]: obj?.[prop1.key] || '',
                            [prop2.key]: obj?.[prop2.key] || '',
                            functions: obj?.functions || []
                        };
                    }
                    else {
                        current[lastKey] = {
                            ...current[lastKey],
                            [prop]: obj
                        };
                    }
                }
                dtoSave = newData;
                return newData;
            } catch (error) {
                return prevData;
            }
        });
        setValue(dtoSave);
        setOpen(false);
    };

    return (
        <div className="treelist-wrapper">
            <TreeList
                style={{ width: "100%" }}
                expandField={expandField}
                subItemsField={subItemsField}
                onExpandChange={onExpandChange}
                sortable={{ mode: "multiple" }}
                onDataStateChange={(e) => {
                    setState({ ...state, dataState: e.dataState });
                }}
                {...state.dataState}
                data={orderBy(
                    filterBy(state.data, state.dataState.filter, subItemsField),
                    state.dataState.sort,
                    subItemsField
                )}
                columns={getColumns(typeComponent, propertys, handleEdit, handleDelete)}
            />

            {open &&
                <EditingAddDialog
                    data={objectEdit}
                    open={open}
                    action={action}
                    propertys={propertys}
                    typeComponent={typeComponent}
                    onClose={setOpen}
                    handleSave={handleSave}
                />
            }
        </div>
    );
};
